/**
 * @generated SignedSource<<46605354b383a762267482e2430bf329>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type MembersChooser_team$fragmentType = any;
type ShowMoreFooter_connection$fragmentType = any;
type row_teamMember$fragmentType = any;
import type { FragmentType } from "relay-runtime";
declare export opaque type Members_team$fragmentType: FragmentType;
export type Members_team$data = {|
  +id: string,
  +members: ?{|
    +count: number,
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +$fragmentSpreads: row_teamMember$fragmentType,
      |},
    |}>,
    +$fragmentSpreads: ShowMoreFooter_connection$fragmentType,
  |},
  +organization: ?{|
    +permissions: {|
      +organizationMemberViewSensitive: ?{|
        +allowed: boolean,
      |},
    |},
  |},
  +$fragmentSpreads: MembersChooser_team$fragmentType,
  +$fragmentType: Members_team$fragmentType,
|};
export type Members_team$key = {
  +$data?: Members_team$data,
  +$fragmentSpreads: Members_team$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeSensitiveInfo"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "pageSize"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "search"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Members_team",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MembersChooser_team"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "pageSize"
        },
        {
          "kind": "Literal",
          "name": "order",
          "value": "NAME"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        }
      ],
      "concreteType": "TeamMemberConnection",
      "kind": "LinkedField",
      "name": "members",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ShowMoreFooter_connection"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamMemberEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TeamMember",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "includeSensitiveInfo",
                      "variableName": "includeSensitiveInfo"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "row_teamMember"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrganizationPermissions",
          "kind": "LinkedField",
          "name": "permissions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Permission",
              "kind": "LinkedField",
              "name": "organizationMemberViewSensitive",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "allowed",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node/*: any*/).hash = "8ef75f100ecde16410e4866deb7043c6";

module.exports = ((node/*: any*/)/*: Fragment<
  Members_team$fragmentType,
  Members_team$data,
>*/);
